export const DELETE_ACCOUNT_PATH = '/delete-account'
export const DELETE_ACCOUNT_CONFIRM_PATH = '/delete-account/confirm'

// Pages that must work without a session (Google Play account deletion), so auth never redirects them to /login.
export const isPublicPath = (pathname: string): boolean =>
  pathname === DELETE_ACCOUNT_PATH || pathname.startsWith(`${DELETE_ACCOUNT_PATH}/`)
